import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import range from 'lodash/range';
import a from '../../../../../redux/actions';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import InlineInput from '../InlineInput';
import InlineSelect from '../InlineSelect';

const percentCleanOptions = range(0.1, 1.1, 0.1).map(value => ({
  value, display: `${Math.round(value * 100)}%`,
})).reverse();

const PurchaseGreenElectricity = ({
  t,
  annualElectricityConsumption,
  purchaseGreenElectricityKwhCO2yr,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <span
        dangerouslySetInnerHTML={{
          __html: t('My household uses {{annualElectricityConsumption}} kilowatt hours of electricity per year, which produces {{purchaseGreenElectricityKwhCO2yr}} metric tons of CO<sub>2</sub>eq per year. I will purchase', { annualElectricityConsumption, purchaseGreenElectricityKwhCO2yr }),
        }}
      />
      <InlineSelect
        apiKey="input_takeaction_purchase_green_electricity_percentclean"
        options={percentCleanOptions}
      />
      {t('of my electricity from a clean energy provider at a cost of')}
      <InlineInput
        currency
        maxLength={5}
        apiKey="input_takeaction_purchase_green_electricity_costclean"
      />
      <span
        dangerouslySetInnerHTML={{
          __html: t('per metric ton of CO<sub>2</sub>eq.'),
        }}
      />
    </div>
    <div className="action-details__facts">
      {t('Voluntary buy-in to EPA-certified green power has soared with 41% annual growth rates since 2004, and one in four utilites now offering the green power upgrade option. If you haven\'t joined yet, it\'s a simple and effective way to green your home\'s power.')}
    </div>
    <div className="action-details__links">
      <a
        href="http://www.coolcalifornia.org/funding-wizard#search/home+electricity//false/none/false/1/12"
        target="_blank"
        rel="noopener noreferrer"
      >{t('Find rebates and incentives for this action')}</a>
    </div>
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        <li>
          {t('cost of electricity')}
          <InlineInput
            apiKey="input_takeaction_assumption_kwhprice"
            maxLength={3}
          />
          {t('cents per kWh')}
        </li>
        <li>
          {t('Green Power Facts Source: National Renewable Energy Laboratory Report - Voluntary Green Power Market Forecast through 2015. May 2010')}&nbsp;
          <a
            href="http://www.nrel.gov/docs/fy10osti/48158.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >{t('nrel.gov PDF')}</a>
        </li>
      </ul>
    </div>
  </div>
);

PurchaseGreenElectricity.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  annualElectricityConsumption: PropTypes.string.isRequired,
  purchaseGreenElectricityKwhCO2yr: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'annualElectricityConsumption',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {
  purchaseGreenElectricityKwhCO2yr: s.results('result_takeaction_purchase_green_electricity_kwhCO2yr', true)(state, ownProps),
});
const mapDispatchToProps = () => ({});

export default wrap(
  withT('purchaseGreenElectricity'),
  connect(mapStateToProps, mapDispatchToProps)(PurchaseGreenElectricity),
);
